module.exports = __webpack_public_path__ + "img/broccoli.00c35357.png";